import { BizzeySetting } from "../../../../packs/widget_shim";
import {
  PublicLocale,
  Widget,
  WidgetCounters,
  WidgetSession,
} from "../../../types";

export const INITIALISE = "INITIALISE";
export const SET_APPLICATION_STATE = "SET_AUTHENTICATION_STATE";
export const SET_BIZZEY_SETTING = "SET_BIZZEY_SETTING";
export const SET_LOCALE = "SET_LOCALE";
export const SET_WIDGET = "SET_WIDGET";
export const SET_WIDGET_SESSION = "SET_WIDGET_SESSION";
export const SET_MESSENGER_FRAME = "SET_MESSENGER_FRAME";
export const ADD_SHOW_LAUNCHER_CALLBACK = "ADD_SHOW_LAUNCHER_CALLBACK";
export const ADD_HIDE_LAUNCHER_CALLBACK = "ADD_HIDE_LAUNCHER_CALLBACK";
export const ADD_READY_CALLBACK = "ADD_READY_CALLBACK";
export const ADD_OPEN_CALLBACK = "ADD_OPEN_CALLBACK";
export const ADD_CLOSE_CALLBACK = "ADD_CLOSE_CALLBACK";
export const MAXIMIZE_WINDOW = "MAXIMIZE_WINDOW";
export const MINIMIZE_WINDOW = "MINIMIZE_WINDOW";
export const TOGGLE_WINDOW_SIZE = "TOGGLE_WINDOW_SIZE";
export const SET_HOST_WINDOW_SIZE = "SET_HOST_WINDOW_SIZE";
export const SET_WINDOW_MAXIMIZED = "SET_WINDOW_MAXIMIZED";
export const SET_WIDGET_COUNTERS = "SET_WIDGET_COUNTERS";

export interface ApplicationState {
  launcherVisible: boolean;
  open: boolean;
  maximized: boolean;
  hostWidth: number;
  hostHeight: number;
  hostMobile: boolean;
  messengerFrame: HTMLIFrameElement | null;
  widget: Widget;
  session: WidgetSession;
  onShowLauncherCallbacks: (() => void)[];
  onHideLauncherCallbacks: (() => void)[];
  onReadyCallbacks: (() => void)[];
  onOpenCallbacks: (() => void)[];
  onCloseCallbacks: (() => void)[];
  bizzeySetting: BizzeySetting;
  locale: PublicLocale;
  counters: WidgetCounters;
}

interface InitialiseAction {
  type: typeof INITIALISE;
  bizzeySetting: BizzeySetting;
}

interface SetAuthenticationStateAction {
  type: typeof SET_APPLICATION_STATE;
  state: ApplicationState;
}

interface SetBizzeySettingAction {
  type: typeof SET_BIZZEY_SETTING;
  bizzeySetting: BizzeySetting;
}

interface SetLocaleAction {
  type: typeof SET_LOCALE;
  locale: PublicLocale;
}

interface SetWidgetAction {
  type: typeof SET_WIDGET;
  widget: Widget;
}

interface SetWidgetSessionAction {
  type: typeof SET_WIDGET_SESSION;
  session: WidgetSession;
}

interface SetMessengerFrameAction {
  type: typeof SET_MESSENGER_FRAME;
  messengerFrame: HTMLIFrameElement;
}

interface AddShowLauncherCallbackAction {
  type: typeof ADD_SHOW_LAUNCHER_CALLBACK;
  callback: () => void;
}

interface AddHideLauncherCallbackAction {
  type: typeof ADD_HIDE_LAUNCHER_CALLBACK;
  callback: () => void;
}

interface AddReadCallbackAction {
  type: typeof ADD_READY_CALLBACK;
  callback: () => void;
}

interface AddOpenCallbackAction {
  type: typeof ADD_OPEN_CALLBACK;
  callback: () => void;
}

interface AddCloseCallbackAction {
  type: typeof ADD_CLOSE_CALLBACK;
  callback: () => void;
}

interface MaximizeWindowAction {
  type: typeof MAXIMIZE_WINDOW;
}

interface MinimizeWindowAction {
  type: typeof MINIMIZE_WINDOW;
}

interface ToggleWindowSizeAction {
  type: typeof TOGGLE_WINDOW_SIZE;
}

interface SetHostWindowSizeAction {
  type: typeof SET_HOST_WINDOW_SIZE;
  width: number;
  height: number;
}

interface SetWindowMaximizedAction {
  type: typeof SET_WINDOW_MAXIMIZED;
  maximized: boolean;
}

interface SetWidgetCountersAction {
  type: typeof SET_WIDGET_COUNTERS;
  counters: WidgetCounters;
}

export type ApplicationActionTypes =
  | InitialiseAction
  | SetAuthenticationStateAction
  | SetBizzeySettingAction
  | SetWidgetAction
  | SetWidgetSessionAction
  | SetLocaleAction
  | SetMessengerFrameAction
  | AddShowLauncherCallbackAction
  | AddHideLauncherCallbackAction
  | AddReadCallbackAction
  | AddOpenCallbackAction
  | AddCloseCallbackAction
  | MaximizeWindowAction
  | MinimizeWindowAction
  | ToggleWindowSizeAction
  | SetHostWindowSizeAction
  | SetWindowMaximizedAction
  | SetWidgetCountersAction;
